<template>
  <div class="HeaderSearch">
    <div class="columns is-multiline is-mobile is-gapless is-middle bounce-input">
      <div class="search-icon is-1 column"></div>
      <div class="column is-11">
        <div class="search-text">
          <es-dropdown v-model="resultOpen" :popStyle="{width: '350px', marginTop:'27px'}" :pushUp="'#search-input|#online-office-button'" trigger="manuel" position="right">
            <input id="search-input" v-model="search" type="text" ref="search" class="input-sm" @focus="isFocus = true; search = query" @blur="focusOut" :placeholder="$t('texts.whatLookingFor')" />
            <div slot="content" class="searchResult">
              <div v-if="loading" class="search-content">
                <div class="loading">
                  <div class="loading-img"></div>
                </div>
              </div>
              <template v-if="hasResult && results.count > 0">
                <div class="description" ><b>{{ query }}</b> için arama sonuçları ({{ results.count }})</div>
                <div class="results">
                  <template v-for="(result, key) in results.results">
                    <div class="resultHeader columns is-gapless">
                      <div class="column title">{{ result.Title }}</div>
                      <div class="column allResult" v-if="result.items.length > 3" v-on:click="openAllResults(key)">Tüm sonuçlar</div>
                    </div>
                    <div class="item" v-on:click="openResult(item.url)" v-for="item in result.items.slice(0, 3)" v-html="searchBold(item.title)"></div>
                  </template>
                </div>
              </template>
              <div class="resultError" v-if="hasResult && results.count === 0">{{ results.message }}</div>
            </div>
          </es-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from '@/service'
import EsDropdown from '@/shared/components/es-dropdown'
import debounce from 'lodash.debounce'
export default {
  name: 'HeaderSearch',
  components: {
    EsDropdown
  },
  data () {
    return {
      search: '',
      loading: false,
      hasResult: false,
      resultOpen: false,
      results: {
        count: 0,
        message: '',
        results: []
      },
      query: '',
      isFocus: false
    }
  },
  methods: {
    focusOut: debounce(function (val) {
      this.isFocus = false
    }, 500),
    openResult: function (url) {
      window.location.pathname = url
      // this.$router.push({path: url})
    },
    openAllResults: function (index) {
      this.$router.push({
        name: 'Search',
        params: {
          query: this.query,
          result: this.results,
          selectedResult: index
        }
      })
    },
    searchBold: function (text) {
      var qry = this.query.split(' ')
      qry.forEach(function (q) {
        var regex = new RegExp(q, 'gi')
        var word = regex.exec(text)
        if (word != null) text = text.replace(regex, '<b>' + word[0] + '</b>')
      })
      return text
    },
    calcResultOpen: function () {
      if (this.isFocus && this.query.length > 0) this.resultOpen = true
      else this.resultOpen = false
    }
  },
  computed: {
    visibileDesc: function () {
      return (this.results.count) ? 'visible' : 'hidden'
    }
  },
  watch: {
    'isFocus': function () {
      this.calcResultOpen()
      // if (!this.isFocus) this.search = ''
    },
    'search': debounce(function (val) {
      this.query = val
    }, 1000),
    'query': function () {
      this.calcResultOpen()
      if (this.query === '') return
      var self = this
      self.results.count = 0
      self.loading = true
      window.dataLayer.push({
        'event': 'SearchQuery',
        'search': this.query
      })
      if (typeof window !== 'undefined') {
        window.ga('send', 'pageview', `/arama?q=${this.query}`)
      }
      service.search(self, self.eventHub, false, this.query).then(function (data) {
        if (data.status === 200) {
          if (data.body.ResultType === 0) {
            self.results = data.body.ReturnObject
            if (self.results.count === 0) {
              self.results.message = this.$t('texts.noResults')
            }
          } else {
            self.results.count = 0
            self.results.message = data.body.ErrorMessage
          }
        } else {
          self.results.count = 0
          self.results.message = this.$t('errors.noResultError')
        }
        self.hasResult = true
        self.loading = false
      })
    }
  }
}
</script>
<style scoped>
.HeaderSearch .bounce-input {
  width: 155px;
  border: solid 1px var(--text-color2);
  padding: 10px 13px;
  font-size: 0.875em;
  text-align: center;
  color: #ffffff;
  border-radius: 4px;
  letter-spacing: -0.3px;
  background-color: var(--dark-bg2);
}
.HeaderSearch .bounce-input input {        
  color: var(--text-color6);
  background-color: transparent;
  border: none;
  height: 23px;
  font-size: 14px;
  letter-spacing: 0.2px;    
}
.HeaderSearch .search-icon {
  width: 1em;
  height: 1em;
}
.HeaderSearch .search-text input {
  width: 90%;
}

.HeaderSearch .search-text input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--text-color6);
  opacity: 1; /* Firefox */
}

.description {
  font-size: 1em;
  font-weight: normal;
  letter-spacing: -0.4px;
  text-align: left;
  color: var(--text-color1);
  padding: 13px 10px;
}
.description b {
  font-weight: 500;
}
.resultHeader {
  background-color: #e9eef1;
  padding: 5px 10px;
  letter-spacing: -0.3px;
  line-height: 20px;
}
.resultHeader.columns.is-gapless {
  margin: 6px 0;
}
.resultHeader.columns.is-gapless:first-child {
  margin-top: 0;
}
.resultHeader .title {
  font-size: 14px;
  font-weight: 500;
  color: #1f252b;
  text-align: left;
  line-height: 20px;
}
.resultHeader .allResult {
  cursor: pointer;
  font-size: 14px;
  letter-spacing: -0.3px;
  text-align: right;
  color: #004fa3;
}
.results .item {
  text-align: left;
  padding: 6px 15px;
  letter-spacing: -0.3px;
  color: #004fa3;
  cursor: pointer;
}
.resultError {
  padding: 15px;
  text-align: center;
}
.searchResult {
  padding-bottom: 7px;
}
.search-content {
  padding: 25px 0;
}
.search-content .loading {
  transform: scale(.6);
}
@media only screen and (min-width: 1080px) {
  .HeaderSearch .bounce-input {
    width: 170px;
  }
}

</style>


// WEBPACK FOOTER //
// src/desktop/widget/header/search.vue